import { render, staticRenderFns } from "./CardButtonGroup.vue?vue&type=template&id=03a4426e&scoped=true"
import script from "./CardButtonGroup.vue?vue&type=script&lang=js"
export * from "./CardButtonGroup.vue?vue&type=script&lang=js"
import style0 from "./CardButtonGroup.vue?vue&type=style&index=0&id=03a4426e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a4426e",
  null
  
)

/* custom blocks */
import block0 from "./CardButtonGroup.vue?vue&type=custom&index=0&blockType=platform-tab&%3AtabData=tabData&%40tabChange=tabChange"
if (typeof block0 === 'function') block0(component)

export default component.exports